import { BaseBackgroundTaskProps } from "@custom-types/sdb-background-tasks-types";
import { BackgroundTaskCategory } from "@custom-types/sdb-background-tasks-types";
import { ICON_SMALL_STYLE } from "@components/header/sphere-avatar";
import { SphereTooltip } from "@components/common/sphere-tooltip";
import {
  CadSmallIcon,
  CameraVideoTrajectorySmallIcon,
  InfoIcon,
  PointCloudIcon,
} from "@flat-ui";

/**
 * Renders the backgrounds task icon to display in the cloud activity table.
 */
export function BackgroundTaskIcon({
  task,
}: BaseBackgroundTaskProps): JSX.Element {
  let iconComponent: JSX.Element;

  switch (task.taskCategory) {
    case BackgroundTaskCategory.pointCloud:
      iconComponent = <PointCloudIcon style={ICON_SMALL_STYLE} />;
      break;
    case BackgroundTaskCategory.videoMode:
      iconComponent = (
        <CameraVideoTrajectorySmallIcon style={ICON_SMALL_STYLE} />
      );
      break;
    case BackgroundTaskCategory.cad:
      iconComponent = <CadSmallIcon style={ICON_SMALL_STYLE} />;
      break;
    default:
      iconComponent = <InfoIcon style={ICON_SMALL_STYLE} />;
      break;
  }

  return (
    <SphereTooltip title={<var>{task.taskType}</var>}>
      {iconComponent}
    </SphereTooltip>
  );
}
